module.exports = __webpack_public_path__ + "media/application/images/icons/arrow-down-69190b60ef27ff5f1cc4c49e238fbff5.svg";